module.exports = __webpack_public_path__ + "img/hypnotizd-0126e9f9-1f9d-4325-489b-08d95b7e528f.png";